import { TFunction } from 'i18next';
import { AssetStatus, ProductTypeName } from '@electricjs/core_entity-client';
import { FilterOption } from 'common/TableFilters/types';
import { IsDeviceFilterOption, Warranty } from '../types';

import { transformProductTypesToOptions } from '@/components/Catalog/utils/helpers';
import { HARDWARE_PRODUCT_TYPES } from '@/constants/catalog';

/** Status filter */
export const getStatusOptions = (t: TFunction): FilterOption<AssetStatus>[] => [
  {
    id: AssetStatus.InUse,
    value: AssetStatus.InUse,
    text: t('status.inUse'),
    disabled: false,
  },
  {
    id: AssetStatus.Available,
    value: AssetStatus.Available,
    text: t('status.available'),
    disabled: false,
  },
  {
    id: AssetStatus.UnderRepair,
    value: AssetStatus.UnderRepair,
    text: t('status.underRepair'),
    disabled: false,
  },
  {
    id: AssetStatus.Donated,
    value: AssetStatus.Donated,
    text: t('status.donated'),
    disabled: false,
  },
  {
    id: AssetStatus.Sold,
    value: AssetStatus.Sold,
    text: t('status.sold'),
    disabled: false,
  },
  {
    id: AssetStatus.Disposed,
    value: AssetStatus.Disposed,
    text: t('status.disposed'),
    disabled: false,
  },
  {
    id: AssetStatus.Missing,
    value: AssetStatus.Missing,
    text: t('status.missing'),
    disabled: false,
  },
  {
    id: AssetStatus.Archived,
    value: AssetStatus.Archived,
    text: t('status.archived'),
    disabled: false,
  },
  {
    id: AssetStatus.InTransit,
    value: AssetStatus.InTransit,
    text: t('status.inTransit'),
    disabled: false,
  },
  {
    id: AssetStatus.WarehouseIntake,
    value: AssetStatus.WarehouseIntake,
    text: t('status.warehouseIntake'),
    disabled: false,
  },
];

/** Product Type filter */
export const getTypeOptions = (): FilterOption<ProductTypeName>[] => {
  // Get only "hardware" product types (e.g., excluding "Services")
  const productTypeOptions = transformProductTypesToOptions().filter(option =>
    HARDWARE_PRODUCT_TYPES.includes(option.value)
  );

  return productTypeOptions.map(option => ({
    id: option.value,
    value: option.value,
    text: option.label,
  }));
};

/** Warranty filter */
export const getWarrantyOptions = (t: TFunction): FilterOption<Warranty>[] => [
  {
    id: Warranty.ACTIVE,
    value: Warranty.ACTIVE,
    text: t('warranties.active'),
  },
  {
    id: Warranty.EXPIRED,
    value: Warranty.EXPIRED,
    text: t('warranties.expired'),
  },
  {
    id: Warranty.UNKNOWN,
    value: Warranty.UNKNOWN,
    text: t('warranties.unknown'),
  },
];

/** Device filter */
export const getDeviceFilterOptions = (
  t: TFunction
): FilterOption<IsDeviceFilterOption>[] => [
  {
    id: IsDeviceFilterOption.YES,
    value: IsDeviceFilterOption.YES,
    text: t('tableFilters.deviceOptions.yes'),
  },
  {
    id: IsDeviceFilterOption.NO,
    value: IsDeviceFilterOption.NO,
    text: t('tableFilters.deviceOptions.no'),
  },
];
